import { useUnits } from '../../units/UnitContext';
import { formatMicrometres } from './fitDisplay';

const FitToleranceZones = ({ hole, shaft }) => {
  const { unitSystem } = useUnits();
  const lower = Math.min(0, hole.deviations.lowerUm, shaft.deviations.lowerUm);
  const upper = Math.max(0, hole.deviations.upperUm, shaft.deviations.upperUm);
  const rawSpan = upper - lower || 1;
  const padding = Math.max(rawSpan * 0.08, 1);
  const plotLower = lower - padding;
  const plotUpper = upper + padding;
  const span = plotUpper - plotLower;
  const toTop = (value) => ((plotUpper - value) / span) * 100;
  const zoneStyle = (tolerance) => {
    const top = toTop(tolerance.deviations.upperUm);
    const bottom = toTop(tolerance.deviations.lowerUm);
    return { top: `${top}%`, height: `${Math.max(bottom - top, 3)}%` };
  };

  return (
    <section className="fitZones" aria-labelledby="fit-zones-title">
      <div className="fitSectionHeading">
        <p>Scaled view</p>
        <h3 id="fit-zones-title">Tolerance zones</h3>
      </div>
      <div className="fitZonesPlot">
        <span
          className="fitZonesZero"
          style={{ top: `${toTop(0)}%` }}
          aria-hidden="true"
        />
        <span className="fitZonesZeroLabel" style={{ top: `${toTop(0)}%` }}>
          Zero
        </span>
        {[
          ['hole', hole],
          ['shaft', shaft],
        ].map(([type, tolerance]) => (
          <div className={`fitZoneLane fitZoneLane--${type}`} key={type}>
            <strong>{type === 'hole' ? 'Hole' : 'Shaft'} · {tolerance.designation}</strong>
            <span className="fitZoneBand" style={zoneStyle(tolerance)} aria-hidden="true" />
          </div>
        ))}
      </div>
      <dl className="fitZoneValues">
        <div>
          <dt>Hole {hole.designation}</dt>
          <dd>{formatMicrometres(hole.deviations.lowerUm, true, unitSystem)} to {formatMicrometres(hole.deviations.upperUm, true, unitSystem)}</dd>
        </div>
        <div>
          <dt>Shaft {shaft.designation}</dt>
          <dd>{formatMicrometres(shaft.deviations.lowerUm, true, unitSystem)} to {formatMicrometres(shaft.deviations.upperUm, true, unitSystem)}</dd>
        </div>
      </dl>
    </section>
  );
};

export default FitToleranceZones;
